import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/unidentified/payments', config);
}

const get = async (code) => {
    return FinanceApi.get('/unidentified/payments/' + code);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/unidentified/payments/' + data.id, data);
    }
    return FinanceApi.post('/unidentified/payments', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/unidentified/payments/' + id, formData);
}

const del = async (id) => {
    return FinanceApi.delete('/unidentified/payments/' + id);
}

const move = async (id, formData) => {
    return FinanceApi.post('/unidentified/payments/' + id + '/move', formData);
}

const close = async (id, formData) => {
    return FinanceApi.post('/unidentified/payments/' + id + '/close', formData);
}

export default {
    getAll,
    get,
    store,
    update,
    del,
    move,
    close
}
